var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-radio-group',{on:{"change":_vm.onChange},model:{value:(_vm.localScheduleType),callback:function ($$v) {_vm.localScheduleType=$$v},expression:"localScheduleType"}},[_c('v-radio',{key:1,attrs:{"label":"Lịch lặp hàng tuần","value":"weekly-schedule"}}),_c('v-radio',{key:2,attrs:{"label":"Lịch tự do","value":"free-schedule"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }